import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBlogs } from '../../features/blogs/blogsSlice';
import PostGridItem from './PostGridItem';

const PostGrid = () => {

    const dispatch = useDispatch();
    const {blogs, isLoading, isError, error} = useSelector((state) =>  state.blogs)
    const {filter, sort} = useSelector((state) => state.filter);

    useEffect(() => {
        dispatch(fetchBlogs({filter, sort}));
    },[dispatch, filter, sort])

    let content;

    if(isLoading){
        content = <div className='text-xl'>Loading...</div>
    }

    if(!isLoading && isError){
        content = <div>{error}</div>
    }

    if(!isLoading && !isError && blogs.length > 0){
        content = blogs.map((blog) => <PostGridItem key={blog.id} blog={blog}/>)
    }
    return (
        <main className="post-container" id="lws-postContainer">
            {content}
      </main>
    );
};

export default PostGrid;